module.exports = __webpack_public_path__ + "img/8.11a4be31.jpg";